import { Api } from "@/services";

export function useResetPassword() {
  const baseUrl = "/public/users";
  const baseUrlPassword = "/public/password-tokens";

  const sendEmailResetPassword = (email: string, captchaToken: string) => {
    return Api.patch(
      `${baseUrl}/reset-password`,
      { email },
      { headers: { "x-captcha-request": captchaToken } }
    );
  };

  const sendNewPassword = (token: string, data: Object) => {
    return Api.patch(`${baseUrlPassword}/${token}`, data);
  };

  return {
    sendEmailResetPassword,
    sendNewPassword,
  };
}
